import { useEffect, useState } from "react";

/**
 * Returns true after the browser is idle or the user interacts.
 * Use to defer non-critical animations so they don't compete with LCP.
 */
export function useDeferredReady(timeout = 2500): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const trigger = () => {
      if (cancelled) return;
      cancelled = true;
      setReady(true);
      cleanup();
    };
    const events = ["pointermove", "pointerdown", "keydown", "scroll", "touchstart"] as const;
    const cleanup = () => {
      events.forEach((e) => window.removeEventListener(e, trigger));
    };
    events.forEach((e) =>
      window.addEventListener(e, trigger, { once: true, passive: true } as AddEventListenerOptions)
    );

    const ric: any = (window as any).requestIdleCallback;
    const idle = ric ? ric(trigger, { timeout }) : window.setTimeout(trigger, Math.min(timeout, 2000));

    return () => {
      cancelled = true;
      cleanup();
      if (ric && (window as any).cancelIdleCallback) (window as any).cancelIdleCallback(idle);
      else window.clearTimeout(idle as number);
    };
  }, [timeout]);

  return ready;
}
